export default "__VITE_PUBLIC_ASSET__735b2113__"